import { faXmark } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";

import { IDeemedCapitalGains } from "../../../../config/interfaces";
import FASvgIcon from "../../../FASvgIcon";

import { Formik } from "formik";
import { cloneDeep } from "lodash";

import { CGDeemedForm } from "..";
import {
  DeemedCapitalGainsFormSchema,
  DeemedCapitalGainsInitValue
} from "../../../../pages/itr-filing/efiling.config";
import { useAppSelector } from "../../../../redux/Store";
import { ITRFilingSelector } from "../../../../redux/slice/ITRFilingSlice";
import ScrollToFirstError from "../../../ScrollToFirstError";

type Props = {
  showCanvas: boolean;
  formValues: IDeemedCapitalGains | null;
  handleCloseBtnPress: (IDeemedCapitalGains: IDeemedCapitalGains | null) => void;
};

const CGDeemedDetailsForm: React.FC<Props> = (props: Props) => {
  const { showCanvas, handleCloseBtnPress, formValues } = props;

  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  const [initFormValues, setInitFormValues] = useState<IDeemedCapitalGains>(
    DeemedCapitalGainsInitValue
  );

  useEffect(() => {
    if (showCanvas && formValues) {
      setInitFormValues(() => cloneDeep(formValues));
    } else {
      setInitFormValues(() => cloneDeep(DeemedCapitalGainsInitValue));
    }
  }, [showCanvas, formValues]);

  return (
    <>
      <Offcanvas show={showCanvas} placement="end" backdrop={true}>
        <Formik
          enableReinitialize={true}
          initialValues={initFormValues}
          validationSchema={DeemedCapitalGainsFormSchema}
          onSubmit={async (values) => {
            handleCloseBtnPress(values);
          }}
        >
          {({
            handleSubmit,
            submitCount,
            isValid,
            values,
            errors,
            touched,
            setValues,
            setFieldValue,
            handleBlur
          }) => (
            <>
              <ScrollToFirstError submitCount={submitCount} isValid={isValid} errors={errors} />

              <Offcanvas.Header>
                <Offcanvas.Title>Deemed Capital Gains Details</Offcanvas.Title>
                <Button
                  variant="primary"
                  className="icon-only hide-offcanvas"
                  onClick={() => handleCloseBtnPress(null)}
                >
                  <FASvgIcon icon={faXmark} />
                </Button>
              </Offcanvas.Header>

              <Offcanvas.Body>
                <CGDeemedForm />
              </Offcanvas.Body>

              <div className="offcanvas-btns">
                {!isFilingReadOnly ? (
                  <Button variant="outline-white" size="sm" onClick={() => handleSubmit()}>
                    Save and Close
                  </Button>
                ) : (
                  <Button
                    variant="outline-white"
                    size="sm"
                    onClick={() => handleCloseBtnPress(null)}
                  >
                    Close
                  </Button>
                )}
              </div>
            </>
          )}
        </Formik>
      </Offcanvas>
    </>
  );
};

export default CGDeemedDetailsForm;
